__turbopack_context__.v({
  "arrow": "Row-module-scss-module__purxuG__arrow",
  "item": "Row-module-scss-module__purxuG__item",
});
